import React, { useEffect, useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import TopicPerformanceTable from './TopicPerformanceTable';
import './index.scss';
import { useTopicTrackingLoading } from '@op/models/loading/useTopicTrackingLoading';
import { useTopicLevelOneList } from './hooks/topicTracking';
import { SentimentTypeFilterMap } from './config';

export default function SentimentTopicsDeepDive(props:any) {
  const { filter, sentimentType, filterCond, filterLoading, ...restProps } = props;

  const filterParams = useMemo(()=> {
    if(!filterCond){
      return {};
    }
    return {
      ...filter,
      social_media_by_account: filterCond?.social_media_by_account || undefined,
      social_media_by_keyword: undefined
    };
  },[filter, filterCond]);

  const { tableData, loading } = useTopicLevelOneList({
    filter: filterParams,
    sentimentType
  });
  const filterValue ={
    ...filterParams,
    sentiment_type: 'total',
    sentiment: [SentimentTypeFilterMap[sentimentType]],
  };

  const { resetLoading } = useTopicTrackingLoading({
    key: 'topicTrackingTimeline',
  });

  useEffect(() => {
    resetLoading(tableData.length > 0);
  }, [tableData]);

  return (
    <CardCommon
      className="dbo-topic-performance-wrapper"
      loading={loading || filterLoading}
      loadingHeight={250}
      logBtnId="TopicPerformance"
    >
      <TopicPerformanceTable
        loading={loading}
        topicLevelList={tableData}
        language={'origin'}
        filter={filterValue}
        sentimentType={sentimentType}
        filterCond={filterCond}
        {...restProps}
      />
    </CardCommon>
  );
}
